import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMale, faFemale } from '@fortawesome/free-solid-svg-icons';
import styles from './EmployeesChart.module.css';

const EmployeesSexeChart = ({ data }) => {
    if (!data || data.length === 0) return null;

    const renderIcons = (category) => {
        const activeIcons = [...Array(Math.round((category.percentage / 100) * category.totalEmployees))].map((_, i) => (
            <FontAwesomeIcon className={styles.icons} key={`${category.label}-active-${i}`} icon={category.label === "Hommes" ? faMale : faFemale} style={{ color: category.color }} />
        ));
        const missingIcons = [...Array(category.totalEmployees - activeIcons.length)].map((_, i) => (
            <FontAwesomeIcon className={styles.icons} key={`${category.label}-missing-${i}`} icon={category.label === "Hommes" ? faMale : faFemale} style={{ color: category.color, opacity: 0.3 }} />
        ));

        return [...activeIcons, ...missingIcons];
    };

    return (
            <>
                {data.map((category, index) => (
                    <div key={index} style={{
                        borderRadius: "6px",
                        backgroundColor: "#f1f1f1",
                        padding: "16px",
                        width: "230px",
                        height: "fit-content"
                    }}>
                        <h4 style={{color: category.color}} className={styles.chartLabel}>
                            {category.label} - {category.percentage}%
                        </h4>
                        <div style={{display: 'flex', flexWrap: 'wrap'}}>
                            {renderIcons(category)}
                        </div>
                    </div>
                ))}
            </>
    );
};

export default EmployeesSexeChart;
